<template>
    <div class="base">
        <label class="base__label container--row">
            <p class="base__label-title">
                {{ title }}
            </p>
            <!-- <span
                v-if="info"
                @mouseover="showImage"
                @mouseleave="showImage"
                class="base__label-info"
            >{{ info }}
            </span>
            <div class="base__label-image" v-if="postfixLabelImage">
                <img
                    alt="postfix image"
                    v-if="postfixLabelImage && active"
                    :src="require('@/assets/icons/' + postfixLabelImage)"
                />
            </div> -->
        </label>
        <div class="container--row base__pin-input">
            <input
                autofocus
                autocomplete="off"
                class=""
                type="password"
                pattern="[0-9]*"
                inputmode="numeric"
                @keydown="formatPinInput($event)"
                v-model="pinValue1"
                @keyup="checkFocusAbility($event, 2)"
                id="pin-input1"
            />
            <input
                class=""
                type="password"
                autocomplete="off"
                pattern="[0-9]*"
                inputmode="numeric"
                v-model="pinValue2"
                @keydown="formatPinInput($event)"
                @keyup="checkFocusAbility($event, 3)"
                id="pin-input2"
            />
            <input
                class=""
                type="password"
                autocomplete="off"
                inputmode="numeric"
                pattern="[0-9]*"
                v-model="pinValue3"
                @keydown="formatPinInput($event)"
                @keyup="checkFocusAbility($event, 4)"
                id="pin-input3"
            />
            <input
                class=""
                type="password"
                autocomplete="off"
                pattern="[0-9]*"
                inputmode="numeric"
                v-model="pinValue4"
                @keydown="formatPinInput($event)"
                @keyup="checkFocusAbility($event, 5)"
                id="pin-input4"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "PinInput",
    emits: ["value-complete"],
    props: {
        indexValue: {
            type: Number,
            required: true,
        },
        focused: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
    },
    mounted() {},
    data() {
        return {
            pinValue1: "",
            pinValue2: "",
            pinValue3: "",
            pinValue4: "",
            procedd: false,
        };
    },
    computed: {},
    methods: {
        formatPinInput(evt) {
            this.procced = true;
            const charCode = evt.which ? evt.which : evt.keyCode;
            this.procced =   this.restrictToAlphabet(charCode, evt);
            if (this.procced && charCode !== 8 && evt.target.value.length >= 1) {
                evt.preventDefault();
            }
        },
        checkFocusAbility(evt, indexValue) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (this.procced) {
                if (charCode !== 8 && indexValue < 5) {
                    document.getElementById("pin-input" + indexValue).focus();
                }
                else {
                    if (indexValue > 2 && charCode === 8) {
                        document.getElementById("pin-input" + (indexValue - 2)).focus();
                    }
                }
            }
            this.checkIfPinComplete();
        },
        checkIfPinComplete() {
            let totalValue =
        this.pinValue1.toString() +
        this.pinValue2.toString() +
        this.pinValue3.toString() +
        this.pinValue4.toString();
            if (totalValue.length === 4) {
                this.$emit("value-complete", totalValue);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>